import type { FeedbackSchema } from '~/shared/domain/models';

interface Feedback {
  feedbackTitle: string;
  feedbackSubtitle: string;
}

export const adaptFeedback = (feedback: Feedback): FeedbackSchema => ({
  title: feedback.feedbackTitle,
  subtitle: feedback.feedbackSubtitle,
});
